import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Circle = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        focusable={false}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Circle
